import { AryaRoom } from '@digital-bridge/artisan-arya';
import { Position2D, Vector2D } from '@digital-bridge/fine';
import { flow } from 'fp-ts/lib/function';
import * as t from 'io-ts';
import { BoundingBox } from '@dora/backpack';
export type Room = AryaRoom;

export const SerialisedRoom = t.type({
    vertices: t.array(t.type({ x: t.number, y: t.number })),
    height: t.number,
});
export type SerialisedRoom = t.TypeOf<typeof SerialisedRoom>;

const origin = new Position2D(0, 0);

export const findBounds = (room: AryaRoom): BoundingBox.BoundingBox => {
    const minimum = room.vertices.reduce((v1, v2) => v1.minimum(v2));
    const maximum = room.vertices.reduce((v1, v2) => v1.maximum(v2));

    return BoundingBox.construct(minimum, maximum);
};

export const dimensions: (room: AryaRoom) => Vector2D = flow(findBounds, BoundingBox.dimensions);

export function centre(room: AryaRoom): Position2D {
    const polygon = room.vertices;
    const xs = polygon.map(v => v.x());
    const ys = polygon.map(v => v.y());

    const minX = Math.min(...xs);
    const minY = Math.min(...ys);
    const maxX = Math.max(...xs);
    const maxY = Math.max(...ys);

    return new Position2D((maxX + minX) / 2, (maxY + minY) / 2);
}

export const recenter = (room: AryaRoom) => {
    const c = centre(room);
    const diff = origin.subtract(c);

    return {
        ...room,
        vertices: room.vertices.map(v => v.translate(diff)),
    };
};

export function deserialise(room: SerialisedRoom): Room {
    return { ...room, vertices: room.vertices.map(v => new Position2D(v.x, v.y)) };
}

export function serialise(room: Room): SerialisedRoom {
    return { ...room, vertices: room.vertices.map(v => ({ x: v.x(), y: v.y() })) };
}
